/**
 * Maps multi chart options to position names and routes
 */

import React from 'react'
import ChartSelector from '../chart-selector'
import ChartSelectorExpanded from '../chart-selector-expanded'
import CHART_MAP from './charts/chart-map'
import RA from 'ra-config'
import { CHART_GROUP_MAP } from '../../config/charts'

function getOptions(name) {
  return CHART_GROUP_MAP.strategies[name].chartOptionList
}

class StrategyCharts extends React.PureComponent {
  static getChart(name, query) {
    let options = getOptions(name)
    let selected = options.find(opt => opt.default === true)

    if (query.expanded === name) {
      selected =
        options.find(opt => opt.text === query.expandedSelection) || selected
    } else if (query[name]) {
      selected = options.find(opt => opt.value === query[name]) || selected
    }

    return selected
  }

  static defaultProps = {
    expanded: false
  }

  render() {
    const { expanded, name, query, ...dataProps } = this.props

    if (name in CHART_GROUP_MAP.strategies === false) {
      return null
    }

    const props = {
      ...dataProps,
      selected: StrategyCharts.getChart(name, query),
      chartMap: CHART_MAP,
      config: RA.content.strategies,
      options: getOptions(name),
      name: name,
      query: query
    }

    return React.createElement(
      expanded ? ChartSelectorExpanded : ChartSelector,
      props
    )
  }
}

export default StrategyCharts



// WEBPACK FOOTER //
// ./src/components/strategies/charts.js